// extracted by mini-css-extract-plugin
module.exports = {"newCode":"newCode--K43MA","newCodeText":"newCodeText--U0EXI","timerBtn":"timerBtn--lE1eR","timerBtnText":"timerBtnText--U4fJ4"};